<!-- trip-segment-popover.component.html -->
<div class="popover-container">
  <!-- Header -->
  <header class="popover-header">
    <div class="header-content">
      <div class="trip-info">
        <span class="pop-title">Trip Segment - {{data?.selectedTripDetails?.id ?? 'Trip'}}</span>
        <span class="trip-status">Trip ID: {{data?.selectedTripDetails?.tripId || data?.summaryData?.tripName }}</span>
      </div>
      <div class="header-actions">
        <!-- <span class="live-tracking">
          Live Tracking
          <span class="live-indicator"></span>
        </span> -->
        <button class="close-btn" (click)="onClose()" aria-label="Close">
          <mat-icon class="close-icon">close</mat-icon>
        </button>
      </div>
    </div>
  </header>

  <!-- Route Information -->
  <!-- <div class="route-section">
      <div class="route-timeline">
        <div class="route-point start">
          <div class="route-marker"></div>
          <div class="route-details">
            <div class="location">MRS 34, Down Road, Nehru Nagar Pune.</div>
            <div class="time">14:30 • Jun 15, 2024</div>
          </div>
        </div>
        <div class="route-line"></div>
        <div class="route-point end">
          <div class="route-marker current"></div>
          <div class="route-details">
            <div class="location">MRS 34, Down Road, Nehru Nagar Pune.</div>
            <div class="time">14:30 • Jun 15, 2024</div>
          </div>
        </div>
      </div>
    </div> -->

  <!-- timeline -->
  <div class="timeline-container">
    <div class="timeline-left">
      <div class="location-details">
        <span class="location-title">{{data?.summaryData?.startLocation | truncate:80:'..'}}</span>
        <span class="location-time">{{data?.summaryData?.startTime | date: 'HH:mm • MMM d, y'}}</span>
      </div>
    </div>

    <div class="timeline-middle">
      <div class="line-start">
        <div class="location-icon"></div>
        <div class="dashed-line"></div>
      </div>
      <div class="line-start">
        <div class="location">
            <div class="node-wrapper">
            <div class="circle-node"></div>
            <div class="solid-line"></div>
        </div>
            <div class="inter-location-wrapper">
                <div class="location-intermediate"></div>
                <span class="location-label">{{(segmentLocation ?? '--') | truncate:80:'..'}}</span>
            </div>
        </div>
      </div>
      <div class="timeline-right">
        <div class="icon-wrapper">
          <div class="doc-icon"></div>
        </div>
        <div class="location-details">
          <span class="location-title">{{data?.summaryData?.endLocation | truncate:80:'..'}}</span>
          <span class="location-time">{{data?.summaryData?.endTime | date: 'HH:mm • MMM d, y'}}</span>
        </div>
      </div>
      <!-- <div class="line-end">
        <div class="vertical-info">
          <div class="location-icon small"></div>
          <div class="dashed-line"></div>
          <div>
            <div class="circle-node"></div>
            <span class="address-text"
            >MRS 34, Down Road,<br />Nehru Nagar Pune.</span
          >
          </div> -->
        <!-- </div> -->
      <!-- </div> -->
    </div>
  </div>
  <div class="status-cards-container">
    <!-- First row of 4 cards -->
  <div class="status-cards-grid">
    <div 
      *ngFor="let card of statusData.slice(0, 4); trackBy: trackByFn" 
      class="status-card">
      <div class="icon-container _{{card?.id}}">
      </div>
      <div class="value-container">
        <span class="value">{{ card.value || card.value === 0 ? card.value : '0' }}</span>
        <span *ngIf="card.unit" class="unit">{{ card.unit }}</span>
      </div>
      <div class="label">{{ card.label }}</div>
    </div>
  </div>
  
  <!-- Second row of 4 cards -->
  <div class="status-cards-grid">
    <div 
      *ngFor="let card of statusData.slice(4, 8); trackBy: trackByFn" 
      class="status-card">
      <div class="icon-container _{{card?.id}}">
      </div>
      <div class="value-container">
        <span class="value">{{ card.value || card.value === 0 ? card.value : '--' }}</span>
        <span *ngIf="card.unit" class="unit">{{ card.unit }}</span>
      </div>
      <div class="label">{{ card.label }}</div>
    </div>
  </div>
  </div>
  <!-- Main Content -->
  <div class="main-content">
    <!-- Battery and Metrics Row -->
    <div class="metrics-row">
      <!-- Battery Status Card -->
      <div class="battery-wrapper">
        <div class="metric-card battery-card">
          <div class="battery-metrics">
            <span class="card-title"> Battery Status </span>
            <div class="range-info">
              <div class="range-item">
                <span class="label">Starting SOC</span>
                <span class="value">{{(startingSoc || startingSoc === 0) ? startingSoc : '--'}}%</span>
              </div>
              <div class="range-item">
                <span class="label">Current SOC</span>
                <span class="value">{{(this.getAttributeValue('battery_soc') || this.getAttributeValue('battery_soc') === '0' )? this.getAttributeValue('battery_soc') : '--'}}%</span>
              </div>
            </div>
          </div>
        </div>
        <div class="metric-card battery-card battery status">
          <div class="battery-warning" *ngIf="data?.battery?.lowBatteryWarning">
            <div class="warning-card {{batteryState}}">
              <div class="warning-content">
                <div class="warning-wrapper">
                <div class="warning {{batteryState}}"></div>
                <div *ngIf="(batteryState && batteryState !== 'full'); else fullCharge">
                  <div class="warning-title {{batteryState}}">“Low Charge - Plug in ASAP!”</div>
                  <div class="warning-subtitle">
                    Charging station 21 km away
                  </div>
                </div>
                <ng-template #fullCharge>
                  <div *ngIf="batteryState === 'full'">
                  <div class="warning-title full">“You’re Covered - Charge Optional”</div>
                  <div class="warning-subtitle">
                    Battery level is healthy—no immediate charging required.
                  </div>
                </div>
                <div *ngIf="batteryState !== 'full'">
                  No Data
                </div>
                </ng-template>
                </div>
                <div class="station-btn" (click)="onGoToStation()">
                  <span class="station-label">Go to Station</span>
                </div>
              </div>
              <div class="station" [ngClass]="{'full': batteryState === 'full'}"></div> 
            </div>
          </div>
        </div>
      </div>
      <!-- Trip Metrics -->
      <div class="trip-metrics">
        <div class="metric-item">
          <span class="metric-icon distance"></span>
          <div class="metric-value">{{ (distanceTravelled || distanceTravelled === 0) ? (distanceTravelled)?.toFixed(2) : '0' }} km</div>
          <div class="metric-label">Distance</div>
        </div>
        <div class="metric-item">
          <span class="metric-icon duration"></span>
          <div class="metric-value">{{ timeTaken ? (timeTaken | duration) : '0 min' }}</div>
          <div class="metric-label">Duration</div>
        </div>
        <div class="metric-item">
          <span class="metric-icon speed"></span>
          <div class="metric-value">{{ (tripDetails?.avgSpeed || tripDetails?.avgSpeed === 0) ? ((tripDetails?.avgSpeed)? (tripDetails?.avgSpeed)?.toFixed(2) : 0)  : '0' }} km/h</div>
          <div class="metric-label">Avg Speed</div>
        </div>
        <div class="metric-item">
          <span class="metric-icon efficiency"></span>
          <div class="metric-value">{{roundOfftoDecmal(data?.selectedTripDetails?.modelOutput?.calculations?.possibleRange) ?? '0'}} km</div>
          <div class="metric-label">Current Range</div>
        </div>
      </div>
    </div>

    <!-- Status Cards Row -->
    <div class="tile2-wrapper" *ngIf="false">
        <!-- Driving Events Card -->
        <div class="events-card">
          <span class="card-title driving-events"> Driving Events </span>
          <div class="events-list">
            <div class="event-item harsh-braking">
              <span class="event-icon"></span>
              <span class="event-label">Harsh Braking</span>
              <span class="event-count">2 events</span>
            </div>
            <div class="event-item harsh-acceleration">
              <span class="event-icon"></span>
              <span class="event-label">Harsh Acceleration</span>
              <span class="event-count">1 event</span>
            </div>
            <div class="event-item overspeed">
              <span class="event-icon"></span>
              <span class="event-label">Overspeed</span>
              <span class="event-count">1 event</span>
            </div>
            <div class="event-item idle-time">
              <span class="event-icon"></span>
              <span class="event-label">Idle Time</span>
              <span class="event-count">8 min</span>
            </div>
          </div>
        </div>
        <!-- Thermal Status Card -->
        <div class="thermal-card">
          <span class="card-title thermal-status"> Thermal Status </span>
          <div class="thermal-list">
            <div class="thermal-item">
              <span class="thermal-label">Battery Temp</span>
              <div class="thermal-value">
                <div class="status-bar good"></div>
                <span class="value">32°C</span>
              </div>
            </div>
            <div class="thermal-item">
              <span class="thermal-label">Motor Temp</span>
              <div class="thermal-value">
                <div class="status-bar warning"></div>
                <span class="value">68°C</span>
              </div>
            </div>
            <div class="thermal-item">
              <span class="thermal-label">Inverter Temp</span>
              <div class="thermal-value">
                <div class="status-bar good"></div>
                <span class="value">38°C</span>
              </div>
            </div>
            <div class="thermal-item">
              <span class="thermal-label">Ambient Temp</span>
              <div class="thermal-value">
                <div class="status-bar good"></div>
                <span class="value">22°C</span>
              </div>
            </div>
          </div>
        </div>
      </div>

    <!-- AI Insights -->
    <div class="insights-section">
      <span class="section-title">AI Insights</span>
      <div class="insights-grid">
        <div class="insight-card eco-performance" *ngFor="let optTips of data?.selectedTripDetails?.modelOutput?.optimizationTips?.slice(0,4)">
          <div class="insight-icon" [ngClass]="{'eco': !getOptimizationAttributesName(optTips?.attributeName)?.icon}">
            <img *ngIf="getOptimizationAttributesName(optTips?.attributeName)?.icon" [src]="getOptimizationAttributesName(optTips?.attributeName)?.icon+token" alt="insight"/>
          </div>
          <div class="insight-content">
            <div class="insight-title">{{getOptimizationAttributesName(optTips?.attributeName)?.attrName || (optTips?.attributeName | titlecase )}}</div>
            <div class="insight-description">
              {{optTips?.text || '--'}}
            </div>
          </div>
        </div>

        <div *ngIf="data?.selectedTripDetails?.modelOutput?.optimizationTips?.length === 0" class="empty-state">
          <svg class="empty-icon" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1">
            <circle cx="12" cy="12" r="10"></circle>
            <path d="M12 6v6l4 2"></path>
          </svg>
          <p class="empty-text">No Insights available</p>
        </div>

        <!-- <div class="insight-card route-optimization">
          <div class="insight-icon route">
          </div>
          <div class="insight-content">
            <div class="insight-title">Route optimization</div>
            <div class="insight-description">
              Consider Highway 101 for 8% faster travel time next trip.
            </div>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</div>
